import { useQuery } from '@tanstack/react-query'
import { requestForServer } from '../Utils/ServerUtil'
import { GET_ORGANIZATIONS } from '../Constants'

/**
 * Custom hook to fetch organizations using React Query
 * 
 * @returns {Object} Object containing organizations data, loading state, and error state
 */
export const useFetchOrganizations = () => {
  return useQuery({
    queryKey: ['organizations'],
    queryFn: async () => {
      const result = await requestForServer(GET_ORGANIZATIONS)
      
      if (result.error) {
        throw new Error(result.error)
      }
      
      return result.data || []
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: 2,
  })
}